// import firebaseAxios from '@/shared/firebase/firebase-axios';
/* eslint-disable */
import { db } from '@/shared/firebase/firebase-init';
const KEY_FIELD_MANAGERS="fieldManagers"

export default {
  list(id) {
    return new Promise((resolve) => {
      db.ref("log")
        .child("logs")
        .child(KEY_FIELD_MANAGERS)
        .orderByChild("id")
        .equalTo(id)
        .once('value').then((snapshot) => { 
        var list = []
        snapshot.forEach(childSnapshot => {
          list.push(childSnapshot.val())
        });

        resolve(list)
      });
    });
  }
};



// WEBPACK FOOTER //
// ./src/entities/field-manager/field-manager-history/field-manager-history-full/field-manager-history-full-service.js